import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Smtp Settings", -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-8 leading-normal"
}, "Sorry you do not have any tenant associated with your account.", -1);
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between mb-8"
}, [/*#__PURE__*/_createElementVNode("h1", {
  "class": "text-3xl font-bold"
}, "Smtp Settings")], -1);
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_7 = {
  "class": "w-1/2 flex"
};
var _hoisted_8 = {
  "class": "w-1/2"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  "class": "w-full p-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")], -1);
var _hoisted_10 = {
  "class": "w-full p-2"
};
var _hoisted_11 = {
  "class": "w-1/2"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  "class": "w-full p-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Campaign")], -1);
var _hoisted_13 = {
  "class": "w-full p-2"
};
var _hoisted_14 = {
  "class": "bg-grey-100 rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_15 = ["onUpdate:modelValue"];
var _hoisted_16 = ["onUpdate:modelValue"];
var _hoisted_17 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return $props.tenantList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Smtp Settings"
  }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets"
  }), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_select, {
    modelValue: $data.tenant,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.tenant = $event;
    }),
    filterable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.getCampaignList();
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (t, t_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: t.id,
          label: t.id
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_select, {
    modelValue: $data.campaign,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.campaign = $event;
    }),
    filterable: "",
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return $options.getSmtpSettings();
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignList, function (c, c_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: c.id,
          label: c.name
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingSmtpSettings,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.smtpSettings,
        style: {
          "width": "100%"
        },
        "row-style": $options.getRowStyle,
        "highlight-current-row": false
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Campaign",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "Email",
            align: "center"
          }, {
            "default": _withCtx(function (scope) {
              return [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.smtpEmail = $event;
                }
              }, null, 8, _hoisted_15), [[_vModelText, scope.row.smtpEmail]])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Settings",
            align: "center"
          }, {
            "default": _withCtx(function (scope) {
              return [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.smtpSettings = $event;
                }
              }, null, 8, _hoisted_16), [[_vModelText, scope.row.smtpSettings]])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Save",
            width: "100"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("button", {
                onClick: function onClick($event) {
                  return $options.saveSettings(scope.row);
                },
                "class": "btn-primary-smaller"
              }, "Save", 8, _hoisted_17)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data", "row-style"])];
    }),
    _: 1
  }, 8, ["loading"])])]));
}